<template>
  <v-card>
    <v-card-text class="pa-0">
      <template>
        <v-toolbar card color="white">
          <v-text-field
            flat
            solo
            prepend-icon="search"
            placeholder="Filtrar"
            v-model="search"
            hide-details
            class="hidden-sm-and-down"
          ></v-text-field>
          <router-link :to="{ name: 'cadastro-praca' }" class="nounderline">
            <v-btn icon>
              <v-icon>add_circle_outline</v-icon>
            </v-btn>
          </router-link>
        </v-toolbar>
        <v-divider></v-divider>
        <v-data-table
          :headers="headers"
          :search="search"
          :items="pracas"
          :rows-per-page-items="[10, 25, 50, { text: 'All', value: -1 }]"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <td>{{ props.item.id }}</td>
            <td>{{ props.item.nomePraca }}</td>
            <td>{{ props.item.nomeFuncionario }}</td>
            <td class="text-xs-right">
              <router-link :to="{ name: 'edit-praca', params: { id: props.item.id } }" class="nounderline">
                <v-btn depressed icon dark color="primary" small>
                  <v-icon small>edit</v-icon>
                </v-btn>
              </router-link>
              <router-link :to="{ name: 'view-praca', params: { id: props.item.id } }" class="nounderline">
                <v-btn depressed icon dark color="primary" small>
                  <v-icon small>remove_red_eye</v-icon>
                </v-btn>
              </router-link>
            </td>
          </template>
        </v-data-table>
      </template>
      <v-divider></v-divider>
    </v-card-text>
  </v-card>
</template>

<script>
import { ServicoPraca } from "../../servicos/servicoPraca"
const servicoPraca = new ServicoPraca()
export default {
  data() {
    return {
      search: "",
      pracas: [],
      headers: [
        {
          text: "Código",
          align: "left",
          value: "id"
        },
        { text: "Praca", align: "left", value: "nomePraca" },
        { text: "Funcionário", align: "left", value: "nomeFuncionario" },
        { text: "", value: "action", align: "right" }
      ]
    }
  },
  created() {
    servicoPraca.buscarPracas().then(
      res => {
        if (res.status === 200) {
          this.pracas = res.data
        }
      },
      // eslint-disable-next-line
      err => console.log(err)
    )
  }
}
</script>
<style>
a.nounderline:link {
  text-decoration: none;
}
</style>
